// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1b8gB","selects":"Documents_selects__3lTOD"};